<template>
  <div class="top">
      <p class="share_button">
        <b-button class="is-info" icon-left="twitter" size="is-small" @click="twitterShare()">{{ $t("message.top_share") }}</b-button>
        <b-button class="line_icon" size="is-small" @click="lineShare()"><i class="fab fa-line"></i>{{ $t("message.top_share") }}</b-button>
      </p>
      <h1>{{ $t("message.top_title") }}</h1>
      <p class="catch_copy">{{ $t("message.top_catch_copy") }}</p>
      <p class="top_img"><img src="../assets/top_image.png" alt="トップのイメージ画像"></p>
      <div v-show="!isLogin" class="login_btn"><router-link to="/login"><b-button type="is-info" size="is-large" rounded>{{ $t("message.top_login_btn") }}</b-button></router-link></div>
        <hr/>
        <h2>{{ $t("message.top_explain_write") }}</h2>
        <p class="top_img"><img src="../assets/topImage4.png" alt="トップのイメージ画像4"></p>
        <p style="text-align:center;">↓</p>
        <p class="top_img"><img src="../assets/topImage2.png" alt="トップのイメージ画像2"></p>
        <p class="catch_copy">{{ $t("message.top_explain_write_catch_copy") }}</p>
        <p class="top_img"><img src="../assets/topImage5.png" alt="トップのイメージ画像5"></p>
        <hr/>
        <p class="catch_copy">{{ $t("message.top_explain_function") }}</p>
      <div class="columns">
        <div class="column">
          <h2>{{ $t("message.top_explain_function_google") }}</h2>
          <p class="top_img"><img src="../assets/google_translate.png" alt="Google翻訳のイメージ"></p>
        </div>
        <div class="column">
          <h2>{{ $t("message.top_explain_function_voice") }}</h2>
          <p class="top_img"><img src="../assets/speeker.png" alt="音声のイメージ画像"></p>
        </div>
        <div class="column">
          <h2>{{ $t("message.top_explain_function_memory") }}</h2>
          <p class="top_img"><img src="../assets/idea.png" alt="アイデアのイメージ画像"></p>
        </div>
        <div class="column">
          <h2>{{ $t("message.top_explain_function_twitter") }}</h2>
          <p class="top_img"><img src="../assets/twitter.png" alt="Twitterのイメージ画像"></p>
        </div>
      </div>
      <p style="text-align:center;font-size:1.5em;">{{ $t("message.top_explain_function_free") }}</p>
      <br>
      <div v-show="!isLogin" class="login_btn"><router-link to="/login"><b-button type="is-info" size="is-large" rounded>{{ $t("message.top_login_btn") }}</b-button></router-link></div>
      <hr/>
      <AdComponent />
      <hr/>
      <h2>{{ $t("message.top_management_info") }}</h2>
      <p>{{ $t("message.top_management_info_name") }}</p>
      <p>{{ $t("message.top_management_info_twitter") }}:<a href="https://twitter.com/katonobo1">かとのぼ</a></p>
      <p>{{ $t("message.top_management_info_request") }}</p>
      <p><router-link to="privacy">{{ $t("message.top_management_info_privacy") }}</router-link></p>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import AdComponent from  './../components/AdComponent.vue'
export default {
  components:{
    AdComponent
  },
  name: 'top',
  data(){
    return{
      isLogin: null
    }
  },
  mounted(){
    const title = "メモや日記ついでに英語学習"
    const description = "あなたの書いたメモや日記を英語に翻訳するアプリです。メモや日記ついでに英語学習ができます。"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  created(){
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        this.isLogin = true
      }else{
        this.isLogin = false
      }
    });
  },
  methods:{
    twitterShare(){
      var twitter_share_url = 'https://twitter.com/intent/tweet?text=' + "%20%23メモや日記ついでに英語学習" + "%20" + "https://translate.ameneko.com/"  
      window.open(twitter_share_url, '_blank')  
    },
    lineShare(){
      var line_share_url = 'https://social-plugins.line.me/lineit/share?url=https://translate.ameneko.com/'
      window.open(line_share_url, '_blank')
    }
  }
}
</script>

<style scoped>
h1{
  text-align: center;
  font-size:1.6em;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 16px;
}
h2{
  text-align: center;
  font-size:1.5em;
  font-weight: bold;
  margin-top: 40px;
  margin-left:10px;
  margin-right: 10px;
  margin-bottom: 16px;
}
p{
  padding: 10px;
}
.top_img{
  text-align: center;
}
.catch_copy{
  font-weight: bold;
  font-size: 1.3em;
  text-align: center;
}
.login_btn{
  text-align: center;
}
.login_text{
  font-size: 1.3em;
  font-weight: bold;
}
img{
  max-width: 300px;
}
.share_button{
  text-align: left;
}
.line_icon{
  margin-left: 8px;
  background-color:#00B901;
  color: white;
}
</style>